<template>
  <vz-button
    large
    variant="primary"
    :icon-name="hasIcon ? 'account' : ''"
    icon-size="19"
    class="public-client-button"
    @click="openVzFeedbackMessageModal"
  >
    Стать клиентом
  </vz-button>
  <vz-feedback-message-modal
    department-code="becomeAClient"
  />
</template>

<script setup lang="ts">
import VzFeedbackMessageModal from '~/components/modals/vz-feedback-message-modal.vue'

const props = defineProps({
  hasIcon : {
    type: Boolean,
    default: true
  }
})

const { $showDialog } = useNuxtApp()

function openVzFeedbackMessageModal(): void {
  $showDialog({ name: 'feedback-message' })
}
</script>